import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-query-loader',
  templateUrl: './query-loader.component.html',
  styleUrls: ['./query-loader.component.css']
})
export class QueryLoaderComponent implements OnInit {
  isLoading: boolean = true;
  @Input() set items(items: any[]) {
    if (items)
      this.isLoading = false
  }
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/loader/query-loader/query-loader.component.ts